<div class="container-fluid content-wrapper">
  <div class="page-title-wrapper d-flex align-items-end justify-content-between">
    <div>
      <h1 class="page-title">Conversation History</h1>
      <span class="page-subtitle">Search for any words or terms used in any conversations</span>
    </div>
    <div class="badge-wrap">
      <span class="count-badge">{{ totalMessages }} Conversations</span>
    </div>
  </div>

  <div class="row">
    <div class="col-12">

      <!-- Filters -->
      <div *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" class="filters-form">
          <div class="row g-3">
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label">Search</label>
                <input
                  class="form-control"
                  type="text"
                  (keyup)="search($event.target.value)"
                  formControlName="search"
                  placeholder="Search content, model, role, conversation..."
                />
              </div>
            </div>

           <!-- ...header and wrapper unchanged... -->

<div class="col-sm-3">
  <div class="form-group bigbeige">
    <label class="col-form-label">Roles</label>
    <select class="form-select bigbeige" multiple formControlName="roles" size="3">
      <option value="user">User</option>
      <option value="assistant">Assistant</option>
      <option value="system">System</option> <!-- added -->
    </select>
    <small class="hint">Hold Ctrl/Cmd to multi-select</small>
  </div>
</div>


<!-- rest unchanged -->


            <div class="col-sm-3">
              <div class="form-group">
                <label class="col-form-label">Model</label>
                <select class="form-select bigbeige" formControlName="model">
                  <option value="">All Models</option>
                  <option *ngFor="let m of availableModels" [value]="m.id">
                    {{ m.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label class="col-form-label">Since</label>
                <div class="input-group">
                  <!-- Keep ngbDatepicker to match your existing deps -->
                  <input
                    class="form-control"
                    name="sinceDate"
                    formControlName="sinceDate"
                    ngbDatepicker
                    #sinceDP="ngbDatepicker"
                    placeholder="Choose date"
                  />
                  <button
                    class="btn datepicker-toggle-btn"
                    type="button"
                    (click)="sinceDP.toggle()"
                    aria-label="Toggle calendar"
                  >
                    <i class="fas fa-calendar-alt"></i>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>

      <!-- Filter Buttons -->
      <div class="row buttons-row no-gutters">
        <button class="col-sm-6 col-md-3 col-lg-2 filters-button" type="button" (click)="toggleFilters()">
          {{ toggleFiltersLabel }}
        </button>
        <button class="col-sm-6 col-md-3 col-lg-2 filters-button" type="button" (click)="clearFilters()">
          Clear filters
        </button>
      </div>

      <!-- Table -->
      <div class="recent-orders row" >
        <div class="col table-wrapper table-responsive" >
          <table
            mat-table
            matSort
            [dataSource]="dataSource"
            class="table table-borderless table-sm recent-orders-table"
          
          >

            <!-- Date -->
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
              <td mat-cell *matCellDef="let r">
                {{ formatDate(r.timestamp) }}
              </td>
            </ng-container>

<!-- Role cell: add class for system -->
<ng-container matColumnDef="role">
  <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
  <td mat-cell *matCellDef="let r">
    <span class="role-chip"
          [class.user]="r.role==='user'"
          [class.assistant]="r.role==='assistant'"
          [class.system]="r.role==='system'"
          style="color: black;">
      {{ r.role }}
    </span>
  </td>
</ng-container>

            <!-- Model -->
            <ng-container matColumnDef="model">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Model </th>
              <td mat-cell *matCellDef="let r">
                <span *ngIf="r.modelDisplayName; else noModel" style="color: beige;">
                  {{ r.modelDisplayName }}
                </span>
                <ng-template #noModel>
                  <span class="muted">—</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- Content -->
            <ng-container matColumnDef="content">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Content </th>
              <td mat-cell *matCellDef="let r">
                <span class="content-preview" [title]="r.content" style="color: beige;">
                  {{ truncate(r.content, 160) }}
                </span>
              </td>
            </ng-container>

            <!-- Image -->
            <ng-container matColumnDef="image">
              <th mat-header-cell *matHeaderCellDef> Img </th>
              <td mat-cell *matCellDef="let r">
                <span class="img-flag" [class.has]="r.hasImage" style="color: beige;">●</span>
              </td>
            </ng-container>

            <!-- Tokens -->
            <ng-container matColumnDef="tokens">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Tokens </th>
              <td mat-cell *matCellDef="let r" style="color: beige;">
                {{ r.tokens || 0 }}
              </td>
            </ng-container>

            <!-- Conversation Path -->
            <ng-container matColumnDef="conversationId">
              <th mat-header-cell *matHeaderCellDef> Path/ID </th>
              <td mat-cell *matCellDef="let r">
                <a
                  class="conversation-link"
                  [routerLink]="['/library/search', r.conversationId]"
                  (click)="$event.stopPropagation()"
                >
                  /library/search/{{ r.conversationId }}
                </a>
              </td>
            </ng-container>

            <!-- Conversation -->
            <ng-container matColumnDef="conversation">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Conversation </th>
              <td mat-cell *matCellDef="let r">
                <button class="link-btn" type="button" (click)="goToConversation(r)" [title]="r.conversationId">
                  {{ truncateConversationTopic(r.conversationTitle) }}
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns;"
              class="clickable-row"
              (click)="goToConversation(row)"
            ></tr>
          </table>

          <mat-paginator
            class="table-paginator bigeasy"
            [pageSizeOptions]="[5, 10, 25, 50]"
            [pageSize]="10"
          ></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
